import { useTokenExpiry } from '@/entities/auth-access';
import { useLogoutListener } from '@/features/listeners/hooks/useLogoutListener';

export const Listeners = () => {
  useTokenExpiry();
  useLogoutListener();
  return null;
};
